<div class="screen-container">
    <div class="container p-0" *ngIf="_appService && _appService.CoreCommonLiterals !== undefined">
      <div class="map-section" *ngIf="!environment.useOfflineMode">
        <ng-container *ngIf="mapApiReady">
          <google-map
            #googleMap
            height="100%"
            width="100%"
            [center]="{ lat: _latitudeCenter, lng: _longitudeCenter }"
            [zoom]="_zoom"
            [options]="{
              maxZoom: commonMapService?.MaxZoom || 18,
              mapTypeId: 'roadmap',
              gestureHandling: 'greedy',
              zoomControl: true,
              mapTypeControl: true,
              mapTypeControlOptions: googleMapOptions?.mapTypeControlOptions || {
                style: 1,
                position: 1
              },
              streetViewControl: true,
              fullscreenControl: true,
              mapId: googleMapOptions?.mapId || 'device-map-id'
            }"
            (mapReady)="onMapReady($event)"
            (centerChanged)="onCenterChange($event)"
            (zoomChanged)="onZoomChange($event)"
          >
        </google-map>
        </ng-container>
      </div>
      <div class="map-section d-flex align-items-center justify-content-center" *ngIf="environment.useOfflineMode">
        <div class="alert alert-warning text-center m-3 w-100">
          <i class="fas fa-map-marked-alt fa-3x mb-3"></i>
          <h4>{{ 'Maps disabled'}}</h4>
          <p>{{'Maps are not available in offline mode.'}}</p>
        </div>
      </div>
      <div  class="pl-0 pl-md-4">
        <app-resizable-panel 
        [minWidth]="200" 
        [maxWidth]="maxPanelWidth" 
        [collapsedWidth]="60"
        [panelId]="'device-panel'"
        [icons]="[{id: 1, tooltip: _appService.CoreCommonLiterals.Devices, class: 'fa-solid fa-house' }]"
        >
      <!-- <div class="col-md-5 pl-0 pl-md-3"> -->
        <div style="height: 100%; overflow: hidden;">
          <div class="card mb-3 shadow-sm">
            <div class="card-block card-body">
              <div class="search-bar">
              <div class="form-group">
                <i class="fa fa-search"></i>
                <input id="map-inputsearch" type="text" class="form-control" [placeholder]="_appService.CoreCommonLiterals.ButtonSearch" [(ngModel)]="searchText" (input)="search($event)" customFocus>
              </div>
            </div>
            <div class="form-group">
              <label for="facilities">{{_appService.CoreCommonLiterals.Facilities}}</label>
              <ss-multiselect-dropdown
                [texts]="_multiSelectTexts" 
                [name]="facilities"
                id="facilities"
                [disabled]="facilitiesList.length === 0 || !addOnMapping?.Enabled"
                #facilities{{i}}="ngModel"
                [settings]="_multiSelectSettings" 
                [options]="facilitiesList"
                (onAdded)="applyFilters('facilities')"
                (onRemoved)="applyFilters('facilities')"
                [(ngModel)]="facilitiesIds"
                >
              </ss-multiselect-dropdown>
            </div>
            <div class="form-group" *ngIf="_deviceID" >
              <label for="devicesSelect">{{_appService.CoreCommonLiterals.Devices}}</label>
              <ss-multiselect-dropdown
                [texts]="_multiSelectTexts" 
                [name]="devices"
                id="devicesSelect"
                [settings]="_multiSelectSettings" 
                [options]="devicesOpts"
                (onAdded)="applyFilters('devices')"
                (onRemoved)="applyFilters('devices')"
                [(ngModel)]="devicesIDs"
                >
              </ss-multiselect-dropdown>
            </div>
          </div>
        </div>
        <div class="result-bar">
          <div class="card mb-3 shadow-sm" 
            *ngFor="let item of clustersFilteredList;"  
            [ngClass]="{'active': item.deviceData.DeviceID == _activeMarker}"
            (mouseover)="onCardHover(item)"
            (mouseout)="onCardMouseOut()"
            id="map-cardfacility-{{item.deviceData.DeviceID}}">
            <div class="card-block card-body">
              <p class="card-title h6 cursor-pointer" (click)="onMarkerClick(item.markerData)">
                <!-- <img [src]="item.deviceData.Stats" width="20px" /> -->
                {{ item.deviceData.Description }} - {{item.deviceData.Facility.Description}}
              </p>
              <p class="card-subtitle text-muted">{{ _gearService.GearCommonLiterals.Identifier }}: {{ item.deviceData.DeviceID }}</p>
              <div class="row">
                <div class="h6 col-7">
                  <span class="badge badge-success mr-1" *ngIf="(!item.deviceData.Stats.Alarms.AlarmCount.InformationSeverity && !item.deviceData.Stats.Alarms.AlarmCount.MidSeverity && !item.deviceData.Stats.Alarms.AlarmCount.LowSeverity && !item.deviceData.Stats.Alarms.AlarmCount.HighSeverity) || 
                    (item.deviceData.ShowGroupedAlarmsOnMaps && item.deviceData.Stats.Alarms.AlarmCount.InformationSeverity && !item.deviceData.Stats.Alarms.AlarmCount.MidSeverity && !item.deviceData.Stats.Alarms.AlarmCount.LowSeverity && !item.deviceData.Stats.Alarms.AlarmCount.HighSeverity)">
                    {{ _appService.CoreCommonLiterals.Normal }}
                  </span>
                  <span class="badge badge-info mr-1" *ngIf="item.deviceData.Stats.Alarms.AlarmCount.InformationSeverity && !item.deviceData.ShowGroupedAlarmsOnMaps">
                    {{_appService.CoreCommonLiterals.InformationAlarm}} : {{item.deviceData.Stats.Alarms.AlarmCount.InformationSeverity}}
                  </span>
                  <span class="badge badge-warning badge-yellow mr-1" *ngIf="item.deviceData.Stats.Alarms.AlarmCount.LowSeverity && !item.deviceData.ShowGroupedAlarmsOnMaps">
                   {{ _appService.CoreCommonLiterals.LowAlarm}} : {{ item.deviceData.Stats.Alarms.AlarmCount.LowSeverity }}
                  </span>
                  <span class="badge badge-warning mr-1" *ngIf="item.deviceData.Stats.Alarms.AlarmCount.MidSeverity && !item.deviceData.ShowGroupedAlarmsOnMaps">
                    {{ _appService.CoreCommonLiterals.MediumAlarm }}: {{ item.deviceData.Stats.Alarms.AlarmCount.MidSeverity }}
                  </span>
                  <span class="badge badge-warning mr-1" *ngIf="(item.deviceData.Stats.Alarms.AlarmCount.LowSeverity || item.deviceData.Stats.Alarms.AlarmCount.MidSeverity) && item.deviceData.ShowGroupedAlarmsOnMaps">
                    {{ _appService.CoreCommonLiterals.Warning }}: {{item.deviceData.Stats.Alarms.AlarmCount.LowSeverity + item.deviceData.Stats.Alarms.AlarmCount.MidSeverity }}
                  </span>
                  <span class="badge badge-danger mr-1" *ngIf="item.deviceData.Stats.Alarms.AlarmCount.HighSeverity">
                    {{item.deviceData.ShowGroupedAlarmsOnMaps ? _appService.CoreCommonLiterals.Error : _appService.CoreCommonLiterals.HighAlarm }}: {{ item.deviceData.Stats.Alarms.AlarmCount.HighSeverity }}
                  </span>
                </div>
                
                <div class="col-5 text-right">
                  <a id="map-btn-views" class="cursor-pointer btn btn-link btn-sm" [tooltip]="_appService.CoreCommonLiterals.GraphicalViewPlans" (click)="goToWithDevice(item.deviceData.Facility, item.deviceData, 'plans')" *ngIf="item.deviceData.Stats?.DefaultIDs.View">
                    <i class="fas fa-object-group"></i>
                  </a>
                  <a id="map-btn-dashboard" class="cursor-pointer btn btn-link btn-sm" [tooltip]="_appService.CoreCommonLiterals?.Dashboards" (click)="goToWithDevice(item.deviceData.Facility, item.deviceData, 'dashboard')" *ngIf="item.deviceData.Stats.DefaultIDs.Dashboard">
                    <i class="fa fa-chart-bar"></i>
                  </a>
                  <a id="map-btn-devices" class="cursor-pointer btn btn-link btn-sm" [tooltip]="_appService?.CoreCommonLiterals?.EndpointsWord" (click)="goToWithDevice(item.deviceData.Facility, item.deviceData, 'devices')">
                    <i class="fa fa-lightbulb"></i>
                  </a>
                  <a id="map-btn-reports" class="cursor-pointer btn btn-link btn-sm" [tooltip]="_appService.CoreCommonLiterals.Alarms" (click)="goToWithDevice(item.deviceData.Facility, item.deviceData, 'reports')">
                    <i class="fa fa-exclamation-triangle"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
            <div *ngIf="status === 0" class="text-center not-found-message">
              <i class="fas fa-circle-notch fa-spin fa-2x"></i>
              <p class="mt-2">{{_appService.CoreCommonLiterals.Loading}}</p>
            </div>
            
            <div *ngIf="status === 1 && clustersFullList.length === 0 && addOnMapping?.Enabled" class="not-found-message text-center mt-5">
              <i class="fa fa-file-alt fa-3x text-primary"></i>
              <p class="mt-3">{{_appService.CoreCommonLiterals.NoDataFound}}</p>
            </div>
          <div *ngIf="!clustersFullList.length && !addOnMapping?.Enabled" class="not-found-message text-center">
            <div class="alert alert-warning w-100" *ngIf="addOnMapping?.Visibility === addOnFeatureVisibility.ShowStar">{{_appService.CoreCommonLiterals.AddOnStarVisibilityMessage}}</div>
            <div class="alert alert-info w-100" *ngIf="addOnMapping?.Visibility === addOnFeatureVisibility.Visible">{{_appService.CoreCommonLiterals.AddOnDisabledTootilp}}</div>
            <div class="alert w-100" *ngIf="environment.useOfflineMode">  
              <i class="fa fa-file-alt fa-3x text-primary"></i>
              <p class="mt-3">{{_appService.CoreCommonLiterals.NoDataFound}}</p>
            </div>
          </div>
        </div>
      </div>
      </app-resizable-panel>
    </div>
  </div>
  
  <modal 
    #deviceModal
    [(successMessage)]="_successMessage"
    [(errorMessage)]="_errorMessage" 
    *ngIf="_appService && _appService.CoreCommonLiterals !== undefined"
    modalClass="modal-lg"
  >
    <modal-header>{{_appService.CoreCommonLiterals.Details}}</modal-header>
    <modal-content>
      <ul class="nav nav-tabs">
        <li class="nav-item" id="map-tab-{{i}}" *ngFor="let b of _deviceModalTextAttributes;let i=index;" (click)="activeTab = i">
          <a type="button" class="nav-link" [class.active]="(activeTab === i)">{{b.Description}}</a>
        </li>
      </ul>
      <div *ngFor="let b of _deviceModalTextAttributes;let i=index;">
        <div class="table-responsive" *ngIf="activeTab === i">
          <table class="table table-condensed table-bordered table-striped">
            <tbody>
              <tr *ngFor="let t of b.TextAttributes">
                <td>
                  {{t.Name}}
                  <i *ngIf="t.IconType ===  1" class="fa fa-info-circle" style="color: blue; text-align: right; float: right;"></i>
                  <i *ngIf="t.IconType ===  2" class="fa fa-exclamation-triangle" style="color: yellow; text-align: right; float: right;"></i>
                  <i *ngIf="t.IconType ===  3" class="fa fa-exclamation-circle" style="color: red; text-align: right; float: right;"></i>
                </td>
                <td *ngIf="t.Value">
                  {{t.Value}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </modal-content>
    <modal-footer>
      <a id="map-btn-close" class="btn btn-primary" (click)="_deviceModal.close()">{{_appService.CoreCommonLiterals.ButtonClose}}</a>
    </modal-footer>
  </modal>